<form class="module-search" [formGroup]="form" (ngSubmit)="onSearch()">
  <button
    type="submit"
    class="search-button"
    aria-label="Search"
    (click)="searchInput.focus()"
  >
    <mat-icon>search</mat-icon>
  </button>
  <input
    #searchInput
    type="text"
    placeholder="Search modules"
    [formControl]="form.controls.search"
    [matAutocomplete]="auto"
    [matAutocompleteDisabled]="isHomeRoute()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    panelWidth="auto"
    (optionSelected)="onOptionSelected($event)"
  >
    @for (module of filteredModules(); track module) {
      @if (!module.hideFromNavigation) {
        <mat-option [value]="module.name">
          {{ module.name }}
        </mat-option>
      }
    }
  </mat-autocomplete>
</form>
